import { HorizontZeile, SubstratZeile } from 'src/app/data-model';

/**
 * Wann traegt eine Zeile des Tiefenprofils etwas bei?
 *
 * Die Uebersicht im Boden-Reiter ist eine Leseansicht. Eine Zeile ohne Tiefe und
 * ohne Inhalt ist dort ein leerer grauer Streifen, an dem sich nichts ablesen
 * laesst - solche Zeilen entstehen beim Erfassen (eine angelegte, noch nicht
 * gefuellte Zeile) und bleiben danach oft stehen.
 *
 * Dieselbe Regel entscheidet zweierlei, und das mit Absicht: ob eine Zeile
 * angezeigt wird UND ob an ihrer Stelle der Platzhalter steht ("Substrat",
 * "Horizonte"). Zwei verschiedene Regeln waeren ein Widerspruch, der sich als
 * leerer Streifen NEBEN dem Platzhalter zeigt (Nutzer-Befund 11.09.2026).
 *
 * Die Tiefe allein genuegt nicht als Merkmal: Wer zuerst das Horizont-Kuerzel
 * eintippt und die Tiefe nachtraegt, soll seine Eingabe sehen.
 */
export function substratZeileHatInhalt(zeile?: SubstratZeile | null): boolean {
	if (!zeile) return false;
	if (Number.isFinite(zeile.tiefe) && zeile.tiefe > 0) return true;
	return !!zeile.substrat;
}

export function horizontZeileHatInhalt(zeile?: HorizontZeile | null): boolean {
	if (!zeile) return false;
	const tiefe = zeile.tiefe;
	if (tiefe !== undefined && Number.isFinite(tiefe) && tiefe > 0) return true;
	return (zeile.horizonte ?? []).some(h => !!h);
}

/** Traegt die Substratfolge ueberhaupt etwas? Sonst steht dort der Platzhalter. */
export function substratfolgeHatInhalt(zeilen?: SubstratZeile[] | null): boolean {
	return !!zeilen?.some(substratZeileHatInhalt);
}

/** Traegt die Horizontfolge ueberhaupt etwas? Sonst steht dort der Platzhalter. */
export function horizontfolgeHatInhalt(zeilen?: HorizontZeile[] | null): boolean {
	return !!zeilen?.some(horizontZeileHatInhalt);
}
